<template>
  <!-- Modal -->
  <div class="modal fade" id="infoVolo" tabindex="-1" aria-labelledby="infoVolo" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modalInfo">
      <div class="modal-content">
        <div class="modal-header">
          <img class="aereoPopup" src="https://www.rimborsoalvolo.it/cresources/outform/images/aereoPopup.svg">
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h2>Dove trovare il numero del tuo volo.</h2>
          <p>Importante: Selezionando la compagnia aerea la parte iniziale viene compilata automaticamente, non resta che inserire la parte numerica composta da quattro cifre.<br>
            Se il tuo numero di volo è composto da 3 soli numeri, inserisci uno zero iniziale: se il tuo volo è FR123 dovrai scrivere FR0123.
            Numeri di volo validi sono : EJU2865, VY6375, FR4001, FR0123, LH0034...
          </p>
        </div>
        <div class="row p-3 txtEmail">
          <div class="col-lg-4 col-md-12 col-sm-12 ticketAereo">
            <img class="ticketAereo" style="width:100%" src="https://www.rimborsoalvolo.it/cresources/outform/images/ticketAereo.svg">
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 txtEmail">
            <div class="row">
              <div class="col-2"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/iconEmail.png"></div>
              <div class="col-8"><h5>Nella tua casella di posta elettronica</h5>
              </div>
            </div>
            <p>Digita il nome della compagnia, o termini come "boarding pass", "ticket", o altri termini attinenti nel motore di ricerca interno.</p>

          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 txtSite ">
            <div class="row">
              <div class="col-2"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/iconSite.png"></div>
              <div class="col-8"><h5>Nel sito web della compagnia o agenzia</h5>
              </div>
            </div>
            <p>Entra nella tua Area Riservata. Troverai lo storico delle tue prenotazioni e biglietti.</p></div>


        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PopupNumero"
}
</script>

<style scoped>

</style>